import React from 'react'
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer'
import Nav from '../../components/Nav/Nav'
import { Colors } from '../../design/Colors';
import { Fonts } from '../../design/Font';
import AccountCard from '../../components/AccountCard/AccountCard';


//import u144 from '../../images/hsa-dashboard/u144.png'//mouseover




export default class AccountManagement extends React.Component{

    constructor(props){
        super(props);
        this.parentRef = React.createRef();
        this.state={
            //modal vars
            view_height:null,
            show_modal:false,

            //Account Summary Box
            contr_year:2023,
            contr_year_list:[2021,2022,2023],
            contr:625.00, //contributions
            ballance:3850.00,
            earnings:21.27,
            earnings_mode:'YTD',
            earning_mode_list:['YTD','This Month', 'Last Month'],
            available_spending:981.27,
            
            //Recent Activity Box
            transactions:[
                {title:'Hometown Pharmacy',date:'June 12', amount:-12.29},
                {title:'Interest',date:'June 01', amount:1.18},
                {title:'Reimbursement',date:'May 27', amount:-9.15},
                {title:'Best Family Practice',date:'May 25', amount:-15.00},
                {title:'DontDisplay Inc.',date:'May 12',amount:100}
            ],

            //card variables
            card1_active:true,
            card2_active:true
        }
    }
    
    componentDidMount=()=>{
        const parentHeight = this.parentRef.current.clientHeight;
        this.setState({ view_height:parentHeight });
    }

    render(){
        return <div ref={this.parentRef} style={{display:'flex',height:"auto", width:'auto',flexDirection:'column', backgroundColor:Colors.light_grey,overflowX:'hidden'}}>
            <Header authed={true} navigator={this.props.navigator}/>
            <div style={{ display:'flex', flexDirection:'row', backgroundColor:Colors.light_grey}}>
                <div style={{ display:'flex',flex:1,justifyContent:'right',alignItems:'right'}}>
                    <Nav navigator={this.props.navigator} page='accountManagement'/>
                </div>
                <div style={{ display:'flex',flexDirection:'column',flex:3, paddingTop:'2.4vh', paddingLeft:"1vw",paddingRight:'20vw'}}>
                    <div>{/**Title*/}
                        <span style={{...Fonts.title,color:"#003F97"}}><span style={{...Fonts.title,color:'#000'}}>Accounts / </span>Account Activity</span>
                    </div>
                    <div style={{background:"#FFF",width:"47vw",height:'100vh', border:'1px solid rgba(215,215,215,1)',borderRadius:5, marginTop:'2.3vh'}}>
                        <div style={{display:'flex',flexDirection:'row',alignItems:'center', marginTop:'2.8vh', marginLeft:'1vw'}}>{/**white view header */}
                            <span style={{...Fonts.title, }}>All Accounts</span>
                        </div>
                        <div>
                            <div style={{display:'flex', flexDirection:'row',marginTop:'2.6vh'}}>
                                <div style={{width:'6vw', marginLeft:'1.4vw'}}><span style={{...Fonts.subtext, color:Colors.dark_grey}}>Account ID</span></div>
                                <div style={{width:'7.8vw'}}><span style={{...Fonts.subtext, color:Colors.dark_grey}}>Account Name</span></div>
                                <div style={{width:'7vw'}}><span style={{...Fonts.subtext, color:Colors.dark_grey}}>Date Created</span></div>
                                <div style={{width:'6vw'}}><span style={{...Fonts.subtext, color:Colors.dark_grey}}>Date Closed</span></div>
                                <div style={{width:'6vw'}}><span style={{...Fonts.subtext, color:Colors.dark_grey}}>Status</span></div>
                                <div style={{width:'7vw'}}><span style={{...Fonts.subtext, color:Colors.dark_grey}}>Select Action</span></div>
                            </div>
                            <AccountCard account_id='AC123456' account_name="John Doe" account_created="June 13, 2023" account_closed="NA" status={true} />
                            <AccountCard account_id='AC123452' account_name="Jane Doe" account_created="May 11, 2023" account_closed="NA" status={false} />
                        </div>
                    </div>
                    <div style={{display:'flex',height:'9vh', background:Colors.light_grey,}}></div>
                </div>
                
            </div>
            
            <Footer/>
        </div>
    }
}